import { Button, Col, Form, Input, Layout, Row, Typography } from "antd";

import { ImagenOptimizada } from "shared-components/Components/Image/web";
import { PageLink } from "shared-components/Components/Link/web";
import { useTheme } from "shared-components/Styles/ThemeHook";

const { Title } = Typography;

export const Header = () => {
	const { theme } = useTheme();

	return (
		<Row className="reset-password-header" justify="end">
			<Col className="header-logo">
				<PageLink pathname="/home" as={""}>
					<div className="logo">
						<ImagenOptimizada
							src={theme.images.logo}
							alt="Logo"
							className="logo_image"
						/>
					</div>
				</PageLink>
			</Col>
		</Row>
	);
};

export const FormInputs = ({ validateRules }) => {
	const { theme } = useTheme();

	return (
		<Row className="reset-password-from-container" gutter={[0, theme.spacing.xxlSpacing]}>
			<Col span={24}>
				<Form.Item
					name="password"
					label={"Nueva contraseña"}
					rules={validateRules.password}
					hasFeedback>
					<Input.Password placeholder={"Nueva contraseña"} />
				</Form.Item>
			</Col>
			<Col span={24}>
				<Form.Item
					name="confirm"
					label={"Repita la contraseña"}
					dependencies={["password"]}
					hasFeedback
					rules={validateRules.confirm}>
					<Input.Password placeholder={"Repita la nueva contraseña"} />
				</Form.Item>
			</Col>
		</Row>
	);
};

export const SaveButton = () => {

	return (
		<Form.Item>
			<Button type="primary" htmlType="submit" block>
				{"Cambiar contraseña"}
			</Button>
		</Form.Item>
	);
};

export const ResetPasswordLayout = ({ form, changePassword, validateForm, validateRules }) => {

	return (
		<Layout className="reset-password-layout">
			<Row justify="center">
				<div className="container reset-password-container">
					<Col span={24}>
						<Header />
					</Col>
					<Col span={24} className="reset-password-content">
						<Col span={24}>
							<Title level={1}>
								{"Para cambiar su contraseña complete el siguiente formulario"}
							</Title>
						</Col>
						<Col span={24}>
							<Form
								form={form}
								name="form_reset_password"
								onFinish={changePassword}
								layout="vertical"
								scrollToFirstError
								validateMessages={validateForm}>
								<FormInputs validateRules={validateRules} />

								<Col span={24} className="reset-password-button-save">
									<SaveButton />
								</Col>
							</Form>
						</Col>
					</Col>
				</div>
			</Row>
		</Layout>
	);
};
